export default "__VITE_ASSET__f38ef425__"